
import {
  CREATE_ORGANISATION_ERROR,
  CREATE_ORGANISATION_PENDING,
  CREATE_ORGANISATION_SUCCESS,
  CLEAR_ORGANISATION_ERROR,
  SET_INITIAL_STATE,
  OPEN_CREATE_ORGANISATION_MODAL,
  CLOSE_CREATE_ORGANISATION_MODAL,
  SET_ORGANISATIONS_PENDING,
  SET_ORGANISATIONS_LIST,
  SET_ORGANISATIONS_LIST_ASYNC,
  ADD_ORG,
  ORGANISATION_LIST_ERROR,
  SET_PAGE_SIZE_GLOBAL,
} from "../organisation/actionTypes";

const initialState = {
  errorMessage: null,
  isPending: false,
  isCreateOrganisationModalOpen: false,
  isGetOrganisationPending: false,
  organisations: [],
  organisationsListAsync: [],
  searchValueAsync: "",
  AddOrganisation: {},
  organisationsCount: null,
  orgListError: null,
  isOrgCreate: false,
  pageSizeGlobal: 0,
};

export default (localState = initialState, action) => {
  switch (action.type) {
    case SET_INITIAL_STATE: {
      return {
        ...initialState,
      };
    }
    case CREATE_ORGANISATION_SUCCESS: {
      return {
        ...localState,
        isPending: false,
        isOrgCreate: true,
      };
    }
    case CREATE_ORGANISATION_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        errorMessage,
        isPending: false,
      };
    }
    case ORGANISATION_LIST_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        orgListError: errorMessage,
        isGetOrganisationPending: false,
        organisations: [],
        organisationsCount: null,
      };
    }
    case CREATE_ORGANISATION_PENDING: {
      return {
        ...localState,
        isPending: true,
      };
    }
    case CLEAR_ORGANISATION_ERROR: {
      return {
        ...localState,
        errorMessage: null,
      };
    }
    case OPEN_CREATE_ORGANISATION_MODAL: {
      return {
        ...localState,
        isCreateOrganisationModalOpen: true,
      };
    }
    case CLOSE_CREATE_ORGANISATION_MODAL: {
      return {
        ...localState,
        isCreateOrganisationModalOpen: false,
        errorMessage: null,
      };
    }
    case SET_ORGANISATIONS_PENDING: {
      return {
        ...localState,
        isGetOrganisationPending: true,
      };
    }
    case SET_ORGANISATIONS_LIST: {
      const { organisationsOdata } = action.payload;
      return {
        ...localState,
        isGetOrganisationPending: false,
        orgListError: null,
        organisations: organisationsOdata && organisationsOdata['value'],
        organisationsCount: organisationsOdata && organisationsOdata['@odata.count'],
        isOrgCreate: false
      };
    }
    case ADD_ORG: {
      const { AddOrganisation } = action.payload;
      return {
        ...localState,
        AddOrganisation: AddOrganisation
      }
    }
    case SET_ORGANISATIONS_LIST_ASYNC: {
      const { organisationsListAsync, searchValueAsync } = action.payload;
      return {
        ...localState,
        organisationsListAsync,
        searchValueAsync,
      };
    }

    case SET_PAGE_SIZE_GLOBAL: {
      const { pageSize } = action.payload;
      return {
        ...localState,
        pageSizeGlobal: pageSize
      };
    }
    default: {
      return localState;
    }
  }
};
